import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbFavorites } from '../../interfaces/eb-favorites.interface'

@Injectable({ providedIn: 'root' })
export class EbFavoritesNormalizer implements Converter<any, EbFavorites> {
  convert(source: any, target: EbFavorites = {}): EbFavorites {
    target.name = source.name
    target.recommendationsList = !!source.recommendationsList
    target.saveTime = new Date(source.saveTime)
    target.savedBy = { ...source.savedBy }
    target.shared = !!source.shared
    return target
  }
}
